import { useState } from "react"
import styled, { ThemeProvider } from "styled-components"
import { lightTheme, darkTheme, GlobalStyles } from "./themes.js"
import DashboardHeader from "./components/dashboard/DashboardHeader"
import DashboardSidebar from "./components/dashboard/DashboardSidebar"
import MainChartSection from "./components/dashboard/MainChartSection"
import MarketOverview from "./components/dashboard/MarketOverview"
import TradingStats from "./components/dashboard/TradingStats"
import TickerTape from "./components/widgets/TickerTape"

const AppContainer = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background-color: ${(props) => props.theme.background};
  color: ${(props) => props.theme.text};
`

const MainContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  
  @media (min-width: 768px) {
    flex-direction: row;
  }
`

const MainArea = styled.main`
  flex: 1;
  padding: 16px;
  
  @media (min-width: 768px) {
    padding: 24px;
  }
`

const GridContainer = styled.div`
  display: grid;
  gap: 24px;
`

const ThreeColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  
  @media (min-width: 992px) {
    grid-template-columns: 2fr 1fr;
  }
`

function App() {
  const [isDarkMode, setIsDarkMode] = useState(true)

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode)
  }

  return (
    <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
      <GlobalStyles />
      <AppContainer>
        <DashboardHeader toggleTheme={toggleTheme} isDarkMode={isDarkMode} />
        <MainContent>
          <DashboardSidebar />
          <MainArea>
            <GridContainer>
              <MainChartSection />
              <TickerTape isDarkMode={isDarkMode} />
              <ThreeColumnGrid>
                <MarketOverview />
                <TradingStats />
              </ThreeColumnGrid>
            </GridContainer>
          </MainArea>
        </MainContent>
      </AppContainer>
    </ThemeProvider>
  )
}

export default App

